export default "__VITE_PUBLIC_ASSET__1e5f3454__"